import Echo, { type PresenceChannel } from "laravel-echo";
import type { Ref } from "vue";
import type { User } from "~/models/User";

export interface UseEcho {
    echo: Ref<Echo>;
    users: Ref<User[]>;
    channel: Ref<PresenceChannel>;
}

export function useEcho(): UseEcho {
    const { $echo, $authenticatedUsers, $authenticatedChannel } =
        useNuxtApp() as {
            $echo: Ref<Echo>;
            $authenticatedUsers: Ref<User[]>;
            $authenticatedChannel: Ref<PresenceChannel>;
        };

    return {
        echo: $echo,
        users: $authenticatedUsers,
        channel: $authenticatedChannel,
    };
}
